"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));
var _utils = require("../../utils");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function Card(props) {
  var data = props.data,
    onClick = props.onClick,
    flexTitle = props.flexTitle,
    desc = props.desc,
    flexSmallTitle = props.flexSmallTitle,
    mergeComponentStatus = props.mergeComponentStatus;
  var _a = data || {},
    title = _a.title,
    _b = _a.rowspan,
    rowspan = _b === void 0 ? 3 : _b,
    _c = _a.configuration,
    configuration = _c === void 0 ? [] : _c;
  if (configuration.length < 1) {
    return null;
  }
  var rowSpan2 = [2].includes(rowspan);
  var handleClick = function handleClick(data) {
    if (!!data.tabIndex && !!data.bindingNum) {
      onClick(data.tabIndex, data.bindingNum);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (flexTitle || desc || flexSmallTitle) && ( /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'product-resource-container--section'
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'h3'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('product-resource-container__card', {
      'product-resource-container__card--row2': rowSpan2
    })
  }, configuration.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      content = _a.content,
      img = _a.img,
      href = _a.href,
      tabIndex = _a.tabIndex,
      bindingNum = _a.bindingNum,
      extendProps = _a.extendProps;
    var url = (0, _utils.fomateFileData)(img).url;
    return /*#__PURE__*/_react["default"].createElement("div", __assign({
      key: index,
      className: (0, _classnames["default"])('list-container', {
        'row-span-2': rowSpan2
      })
    }, extendProps || {}, {
      onClick: function onClick() {
        return handleClick(item);
      }
    }), !!tabIndex && !!bindingNum ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list', {
        'list-row-2': rowSpan2
      })
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])('content', {
        'content-row-2': rowSpan2
      })
    }, /*#__PURE__*/_react["default"].createElement("strong", {
      className: 'strong'
    }, title), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span'
    }, content)), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'right-bg'
    }), url && ( /*#__PURE__*/_react["default"].createElement("img", {
      className: (0, _classnames["default"])('img', {
        'img-row-2': rowSpan2
      }),
      src: url
    })))) : ( /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: (0, _classnames["default"])('list', {
        'list-row-2': rowSpan2
      }),
      href: href,
      target: '_blank',
      rel: "noreferrer"
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])('content', {
        'content-row-2': rowSpan2
      })
    }, /*#__PURE__*/_react["default"].createElement("strong", {
      className: 'strong'
    }, title), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span'
    }, content)), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'right-bg'
    }), url && ( /*#__PURE__*/_react["default"].createElement("img", {
      className: (0, _classnames["default"])('img', {
        'img-row-2': rowSpan2
      }),
      src: url
    })))));
  }))));
}
var ResourceCard = function ResourceCard(props) {
  var paddingTopNum = props.paddingTopNum,
    paddingBottomNum = props.paddingBottomNum,
    flexTitle = props.flexTitle,
    style = props.style,
    isFooterPart = props.isFooterPart,
    isCombination = props.isCombination,
    isPadding = props.isPadding;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isPadding: isPadding,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(Card, __assign({}, props)));
};
var _default = exports["default"] = ResourceCard;